/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CustomDefaultLeadViewSettingBody } from '../models';
// @ts-ignore
import { GetCustomDefaultLeadViewSetting200Response } from '../models';
// @ts-ignore
import { GetCustomDefaultLeadViewSetting404Response } from '../models';
/**
 * CustomDefaultLeadViewSettingApi - axios parameter creator
 * @export
 */
export const CustomDefaultLeadViewSettingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * カスタムデフォルトリードビュー設定取得API
         * @summary カスタムデフォルトリードビュー設定取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomDefaultLeadViewSetting: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/custom_default_lead_view_setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * カスタムデフォルトリードビュー設定更新API（upsert）
         * @summary カスタムデフォルトリードビュー設定更新API
         * @param {CustomDefaultLeadViewSettingBody} customDefaultLeadViewSettingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCustomDefaultLeadViewSetting: async (customDefaultLeadViewSettingBody: CustomDefaultLeadViewSettingBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customDefaultLeadViewSettingBody' is not null or undefined
            assertParamExists('putCustomDefaultLeadViewSetting', 'customDefaultLeadViewSettingBody', customDefaultLeadViewSettingBody)
            const localVarPath = `/api/user/custom_default_lead_view_setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customDefaultLeadViewSettingBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomDefaultLeadViewSettingApi - functional programming interface
 * @export
 */
export const CustomDefaultLeadViewSettingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomDefaultLeadViewSettingApiAxiosParamCreator(configuration)
    return {
        /**
         * カスタムデフォルトリードビュー設定取得API
         * @summary カスタムデフォルトリードビュー設定取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomDefaultLeadViewSetting(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomDefaultLeadViewSetting200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomDefaultLeadViewSetting(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * カスタムデフォルトリードビュー設定更新API（upsert）
         * @summary カスタムデフォルトリードビュー設定更新API
         * @param {CustomDefaultLeadViewSettingBody} customDefaultLeadViewSettingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putCustomDefaultLeadViewSetting(customDefaultLeadViewSettingBody: CustomDefaultLeadViewSettingBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putCustomDefaultLeadViewSetting(customDefaultLeadViewSettingBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomDefaultLeadViewSettingApi - factory interface
 * @export
 */
export const CustomDefaultLeadViewSettingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomDefaultLeadViewSettingApiFp(configuration)
    return {
        /**
         * カスタムデフォルトリードビュー設定取得API
         * @summary カスタムデフォルトリードビュー設定取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomDefaultLeadViewSetting(options?: any): AxiosPromise<GetCustomDefaultLeadViewSetting200Response> {
            return localVarFp.getCustomDefaultLeadViewSetting(options).then((request) => request(axios, basePath));
        },
        /**
         * カスタムデフォルトリードビュー設定更新API（upsert）
         * @summary カスタムデフォルトリードビュー設定更新API
         * @param {CustomDefaultLeadViewSettingBody} customDefaultLeadViewSettingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCustomDefaultLeadViewSetting(customDefaultLeadViewSettingBody: CustomDefaultLeadViewSettingBody, options?: any): AxiosPromise<void> {
            return localVarFp.putCustomDefaultLeadViewSetting(customDefaultLeadViewSettingBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomDefaultLeadViewSettingApi - interface
 * @export
 * @interface CustomDefaultLeadViewSettingApi
 */
export interface CustomDefaultLeadViewSettingApiInterface {
    /**
     * カスタムデフォルトリードビュー設定取得API
     * @summary カスタムデフォルトリードビュー設定取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomDefaultLeadViewSettingApiInterface
     */
    getCustomDefaultLeadViewSetting(options?: AxiosRequestConfig): AxiosPromise<GetCustomDefaultLeadViewSetting200Response>;

    /**
     * カスタムデフォルトリードビュー設定更新API（upsert）
     * @summary カスタムデフォルトリードビュー設定更新API
     * @param {CustomDefaultLeadViewSettingBody} customDefaultLeadViewSettingBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomDefaultLeadViewSettingApiInterface
     */
    putCustomDefaultLeadViewSetting(customDefaultLeadViewSettingBody: CustomDefaultLeadViewSettingBody, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for putCustomDefaultLeadViewSetting operation in CustomDefaultLeadViewSettingApi.
 * @export
 * @interface CustomDefaultLeadViewSettingApiPutCustomDefaultLeadViewSettingRequest
 */
export interface CustomDefaultLeadViewSettingApiPutCustomDefaultLeadViewSettingRequest {
    /**
     * 
     * @type {CustomDefaultLeadViewSettingBody}
     * @memberof CustomDefaultLeadViewSettingApiPutCustomDefaultLeadViewSetting
     */
    readonly customDefaultLeadViewSettingBody: CustomDefaultLeadViewSettingBody
}

/**
 * CustomDefaultLeadViewSettingApi - object-oriented interface
 * @export
 * @class CustomDefaultLeadViewSettingApi
 * @extends {BaseAPI}
 */
export class CustomDefaultLeadViewSettingApi extends BaseAPI implements CustomDefaultLeadViewSettingApiInterface {
    /**
     * カスタムデフォルトリードビュー設定取得API
     * @summary カスタムデフォルトリードビュー設定取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomDefaultLeadViewSettingApi
     */
    public getCustomDefaultLeadViewSetting(options?: AxiosRequestConfig) {
        return CustomDefaultLeadViewSettingApiFp(this.configuration).getCustomDefaultLeadViewSetting(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * カスタムデフォルトリードビュー設定更新API（upsert）
     * @summary カスタムデフォルトリードビュー設定更新API
     * @param {CustomDefaultLeadViewSettingApiPutCustomDefaultLeadViewSettingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomDefaultLeadViewSettingApi
     */
    public putCustomDefaultLeadViewSetting(requestParameters: CustomDefaultLeadViewSettingApiPutCustomDefaultLeadViewSettingRequest, options?: AxiosRequestConfig) {
        return CustomDefaultLeadViewSettingApiFp(this.configuration).putCustomDefaultLeadViewSetting(requestParameters.customDefaultLeadViewSettingBody, options).then((request) => request(this.axios, this.basePath));
    }
}
